import { LANGUAGE } from '#@/__gql__/graphql';

export const websiteRoutes = {
  principalUserHelpUrl: (language = LANGUAGE.de) =>
    language === LANGUAGE.de ? 'https://help.cosuno.com' : 'https://help.cosuno.com/en',
  agentUserHelpUrl: (language = LANGUAGE.de) =>
    language === LANGUAGE.de
      ? 'https://help.cosuno.com/de/collections/2500825-fur-handwerker'
      : 'https://help.cosuno.com/en/collections/2500825-you-are-a-subcontractor',
  agentLearnMoreUrl: (page: string, campaign: string, language: LANGUAGE) =>
    language === LANGUAGE.de
      ? `https://www.cosuno.com/de/subcontractor-features?utm_source=product&utm_medium=${page}&utm_campaign=${campaign}`
      : `https://www.cosuno.com/subcontractor-features?utm_source=product&utm_medium=${page}&utm_campaign=${campaign}`,
  learnMoreAboutCosunoMarketplaceUrl: (language: LANGUAGE | undefined) =>
    language === LANGUAGE.de
      ? 'https://help.cosuno.com/de/articles/7793571'
      : 'https://help.cosuno.com/en/articles/7793571',
  learnMoreAboutBoQAssistant: (language: LANGUAGE) =>
    language === LANGUAGE.de
      ? 'https://help.cosuno.com/de/articles/10023808-lv-assistent-fur-eine-schnellere-lv-erstellung'
      : 'https://help.cosuno.com/en/articles/10023808-boq-assistant',
  learnMoreAboutPriceAssistant: (language: LANGUAGE) =>
    language === LANGUAGE.de
      ? 'https://help.cosuno.com/de/articles/9713464-cosuno-ki-preis-assistent'
      : 'https://help.cosuno.com/en/articles/9713464-cosuno-ai-price-assistant',
};
